import { Input } from "@visiblethread/react-components";
import clsx from "clsx";
import PropTypes from "prop-types";

import styles from "./DatePicker.module.scss";

const DatePicker = ({
  value = "",
  onChange = () => {},
  placeholder = "Select a date",
  id,
  name = id,
  disabled = false,
  error = false,
  className = "",
  label = "",
  min,
  max,
  ...props
}) => {
  const handleChange = (e) => onChange(e);

  return (
    <div className={clsx(styles["date_picker"], className)}>
      {label && (
        <label htmlFor={id} style={{ marginBottom: 0 }}>
          {label}
        </label>
      )}
      <Input
        id={id}
        name={name}
        type="date"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        error={error}
        min={min}
        max={max}
        {...props}
      />
    </div>
  );
};

DatePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
};

export default DatePicker;
